'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _axios = require('../util/axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_ENDPOINT = 'v2/me';

exports.default = function () {
  return new _promise2.default(function (resolve, reject) {
    return _axios2.default.get(API_ENDPOINT).then(function (response) {
      if (response.status >= 200 && response.status <= 299) {
        resolve(response.data);
      } else {
        reject(response);
      }
    }).catch(function (error) {
      return reject(error);
    });
  });
};